function init() {
	//
}

jQuery(document).ready(function() {
	init();
});






// WEBPACK FOOTER //
// ./assets/js/app.js